var _rect, _path, _rect2, _path2, _rect3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.51245,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    transform: "rotate(13.1855 5.51245 0)",
    fill: "url(#paint0_linear_899_22)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6548 13.8616L18.4402 14.5142L12.155 20.4391L13.3871 15.1797L10.6017 14.5271L16.8869 8.60225L15.6548 13.8616Z",
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.158447,
    y: 5.31445,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    transform: "rotate(-12.3207 0.158447 5.31445)",
    fill: "url(#paint1_linear_899_22)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2811 13.4582L18.076 12.8478L14.9547 20.9017L13.802 15.6243L11.0071 16.2347L14.1284 8.18083L15.2811 13.4582Z",
    fill: "#F5F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.41699,
    y: 2.41602,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    fill: "url(#paint2_linear_899_22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6001 7.59473H17.3999C19.6093 7.59473 21.4045 9.3899 21.4045 11.5994V17.3992C21.4045 18.4613 20.9826 19.4798 20.2316 20.2309C19.4806 20.9819 18.462 21.4038 17.3999 21.4038H11.6001C9.39064 21.4038 7.59546 19.6086 7.59546 17.3992V11.5994C7.59546 10.5373 8.01737 9.51867 8.76839 8.76765C9.5194 8.01664 10.538 7.59473 11.6001 7.59473ZM11.462 8.97563C10.8028 8.97563 10.1705 9.23751 9.70439 9.70366C9.23824 10.1698 8.97636 10.802 8.97636 11.4613V17.5372C8.97636 18.9113 10.088 20.0229 11.462 20.0229H17.538C18.1972 20.0229 18.8294 19.761 19.2956 19.2949C19.7617 18.8287 20.0236 18.1965 20.0236 17.5372V11.4613C20.0236 10.0873 18.912 8.97563 17.538 8.97563H11.462ZM18.1249 10.0113C18.3538 10.0113 18.5733 10.1022 18.7351 10.2641C18.897 10.426 18.9879 10.6455 18.9879 10.8744C18.9879 11.1033 18.897 11.3228 18.7351 11.4847C18.5733 11.6465 18.3538 11.7374 18.1249 11.7374C17.896 11.7374 17.6764 11.6465 17.5146 11.4847C17.3527 11.3228 17.2618 11.1033 17.2618 10.8744C17.2618 10.6455 17.3527 10.426 17.5146 10.2641C17.6764 10.1022 17.896 10.0113 18.1249 10.0113ZM14.5 11.047C15.4156 11.047 16.2937 11.4107 16.9411 12.0581C17.5885 12.7056 17.9522 13.5837 17.9522 14.4993C17.9522 15.4149 17.5885 16.293 16.9411 16.9404C16.2937 17.5878 15.4156 17.9515 14.5 17.9515C13.5844 17.9515 12.7063 17.5878 12.0589 16.9404C11.4114 16.293 11.0477 15.4149 11.0477 14.4993C11.0477 13.5837 11.4114 12.7056 12.0589 12.0581C12.7063 11.4107 13.5844 11.047 14.5 11.047ZM14.5 12.4279C13.9506 12.4279 13.4238 12.6461 13.0353 13.0346C12.6469 13.423 12.4286 13.9499 12.4286 14.4993C12.4286 15.0486 12.6469 15.5755 13.0353 15.9639C13.4238 16.3524 13.9506 16.5706 14.5 16.5706C15.0493 16.5706 15.5762 16.3524 15.9647 15.9639C16.3531 15.5755 16.5713 15.0486 16.5713 14.4993C16.5713 13.9499 16.3531 13.423 15.9647 13.0346C15.5762 12.6461 15.0493 12.4279 14.5 12.4279Z",
    fill: "#F0EDE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_22",
    x1: 5.51245,
    y1: 0,
    x2: 30.0834,
    y2: 0.418806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_22",
    x1: 0.158447,
    y1: 5.31445,
    x2: 24.7294,
    y2: 5.73326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_22",
    x1: 2.41699,
    y1: 2.41602,
    x2: 26.988,
    y2: 2.83482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.52cd324c250d4fd2f3739b2017a75371.svg";
export { ForwardRef as ReactComponent };